import React from 'react';

class InvitationSent extends React.Component {
  constructor(props) {
    super(props);
    this.handleSendAnother = this.handleSendAnother.bind(this);
  }

  handleSendAnother() {
    this.props.onClick();
  }

  render() {
    return (
      <div className="response-container">
        <div className="confirmation-message">
          <h5 className="m-0">Friend Request Sent! </h5>
        </div>
        <button
          className="btn btn-primary w-100 mt-2"
          onClick={this.handleSendAnother}
        >
          SEND ANOTHER
        </button>
      </div>
    );
  }
}
export default InvitationSent;
